import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import CommentBoxLayout from '../../../../layouts/CommentBoxLayout';
import CommentBoxAvatar from '../../../../partials/CommentBoxAvatar';
import CommentForAnonymous from '../../../../../CommentForAnonymous';
var AnonymousView = function () {
    var isMobile = useContext(MobileContext);
    return (React.createElement(CommentBoxLayout, { avatar: !isMobile && React.createElement(CommentBoxAvatar, { withLink: false }), content: React.createElement(CommentForAnonymous, null) }));
};
AnonymousView.displayName = 'AnonymousView';
export default AnonymousView;
//# sourceMappingURL=AnonymousView.js.map